<template>
  <SideBar />
  <div class="p-4 sm:ml-64 min-h-screen dark:bg-gray-900 text-white">
    <div class="container mx-auto p-4">
      <!-- Componente de carga -->
      <h1 class="text-3xl font-bold mb-6">Lista de Presupuestos</h1>

      <!-- Formulario de búsqueda -->
      <div class="bg-gray-800 p-4 rounded-lg shadow-lg mb-6">
        <!-- Botones de filtros predeterminados -->
        <div class="mb-4">
          <label class="block text-gray-400 mb-2">Filtros rápidos:</label>
          <div class="flex flex-wrap gap-2">
            <button
              @click="aplicarFiltroRapido('ultimos14Dias')"
              type="button"
              :class="[
                'px-3 py-2 rounded-lg text-sm font-medium transition',
                filtroActivo === 'ultimos14Dias'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600',
              ]"
            >
              Últimos 14 días
            </button>
            <button
              @click="aplicarFiltroRapido('ultimoMes')"
              type="button"
              :class="[
                'px-3 py-2 rounded-lg text-sm font-medium transition',
                filtroActivo === 'ultimoMes'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600',
              ]"
            >
              Último mes
            </button>
            <button
              @click="aplicarFiltroRapido('ultimoTrimestre')"
              type="button"
              :class="[
                'px-3 py-2 rounded-lg text-sm font-medium transition',
                filtroActivo === 'ultimoTrimestre'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600',
              ]"
            >
              Último trimestre
            </button>
            <button
              @click="aplicarFiltroRapido('ultimoAnio')"
              type="button"
              :class="[
                'px-3 py-2 rounded-lg text-sm font-medium transition',
                filtroActivo === 'ultimoAnio'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600',
              ]"
            >
              Último año
            </button>
            <button
              @click="aplicarFiltroRapido('desdeInicioAnio')"
              type="button"
              :class="[
                'px-3 py-2 rounded-lg text-sm font-medium transition',
                filtroActivo === 'desdeInicioAnio'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600',
              ]"
            >
              Desde inicio del año
            </button>
            <button
              @click="aplicarFiltroRapido('personalizado')"
              type="button"
              :class="[
                'px-3 py-2 rounded-lg text-sm font-medium transition',
                filtroActivo === 'personalizado'
                  ? 'bg-green-600 text-white'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600',
              ]"
            >
              Personalizado
            </button>
          </div>
        </div>

        <form @submit.prevent="buscarPresupuestos">
          <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
            <!-- Campo de búsqueda por nombre -->
            <div>
              <label class="block text-gray-400 mb-2" for="nombreCliente"
                >Cliente</label
              >
              <input
                v-model="filtros.nombre"
                type="text"
                id="nombreCliente"
                placeholder="Ingrese el nombre"
                class="w-full p-2 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <!-- Campo de rango de fecha inicial -->
            <div class="w-full">
              <label class="block text-gray-400 mb-2" for="fechaInicio"
                >Fecha Inicio</label
              >
              <input
                v-model="filtros.fechaInicio"
                type="date"
                id="fechaInicio"
                :disabled="filtroActivo !== 'personalizado'"
                :class="[
                  'w-full p-2 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500',
                  filtroActivo !== 'personalizado'
                    ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                    : 'bg-gray-700',
                ]"
              />
            </div>

            <!-- Campo de rango de fecha final -->
            <div class="w-full">
              <label class="block text-gray-400 mb-2" for="fechaFin"
                >Fecha Fin</label
              >
              <input
                v-model="filtros.fechaFin"
                type="date"
                id="fechaFin"
                :disabled="filtroActivo !== 'personalizado'"
                :class="[
                  'w-full p-2 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500',
                  filtroActivo !== 'personalizado'
                    ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                    : 'bg-gray-700',
                ]"
              />
            </div>

            <div class="w-full">
              <label class="block text-gray-400 mb-2" for="fechaFin"
                >Filtrar</label
              >
              <button
                type="submit"
                class="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-lg transition md:mt-0"
              >
                <i class="fas fa-refresh"></i>
              </button>
            </div>
          </div>
        </form>
      </div>

      <router-link
        to="/presupuesto"
        class="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex justify-center mb-6"
        exact-active-class="bg-gray-100 dark:bg-orange-500"
      >
        Nuevo presupuesto
      </router-link>

      <RowComponent
        v-for="presupuesto in presupuestosFiltrados"
        :key="presupuesto.ID"
        :data="presupuesto"
        :h1="[
          presupuesto.CLIENTE,
          `$${parseFloat(presupuesto.TOTAL).toLocaleString('es-ES')}`,
        ]"
        :h2="[`Fecha: ${new Date(presupuesto.DATE).toLocaleDateString()}`]"
        :actions="actions"
      />
    </div>
  </div>
</template>

<script>
import SideBar from "../components/NavBar.vue";
import PresupuestosProvider from "@/helpers/providers/PresupuestosProvider";
import RowComponent from "@/components/RowComponent.vue";

export default {
  name: "PresupuestoPage",
  data() {
    return {
      presupuestos: [], // Lista completa de presupuestos
      filtroActivo: "ultimos14Dias", // Filtro activo por defecto
      filtros: {
        nombre: "", // Nombre del cliente
        fechaInicio: new Date(new Date().setDate(new Date().getDate() - 14))
          .toISOString()
          .substr(0, 10), // Fecha de inicio (últimos 14 días)
        fechaFin: new Date(new Date().setDate(new Date().getDate() + 1))
          .toISOString()
          .substr(0, 10), // Fecha final
      },
      actions: [
        {
          icon: "fas fa-file-pdf",
          iconColor: "bg-orange-500",
          tooltip: "Ver PDF",
          onClick: (data) => this.handlePresupuestoClick(data.UUID),
        },
        {
          icon: "fas fa-usd",
          iconColor: "bg-green-500",
          tooltip: "Generar Venta",
          onClick: (data) => this.handleventaClick(data.UUID),
        },
        {
          icon: "fas fa-pen",
          iconColor: "bg-blue-500",
          tooltip: "Editar presupuesto",
          onClick: (data) => this.handleEditClick(data.UUID),
        },
        {
          icon: "fas fa-trash",
          iconColor: "bg-red-500",
          tooltip: "Eliminar presupuesto",
          onClick: (data) => this.handleDeleteClick(data),
        },
      ],
    };
  },
  computed: {
    // Filtrar presupuestos según los criterios de búsqueda
    presupuestosFiltrados() {
      return this.presupuestos.filter((presupuesto) => {
        const coincideNombre =
          !this.filtros.nombre ||
          presupuesto.CLIENTE.toLowerCase().includes(
            this.filtros.nombre.toLowerCase()
          );
        const coincideFechaInicio =
          !this.filtros.fechaInicio ||
          new Date(presupuesto.DATE) >= new Date(this.filtros.fechaInicio);
        const coincideFechaFin =
          !this.filtros.fechaFin ||
          new Date(presupuesto.DATE) <= new Date(this.filtros.fechaFin);

        return coincideNombre && coincideFechaInicio && coincideFechaFin;
      });
    },
  },
  components: {
    SideBar,
    RowComponent,
  },
  methods: {
    // Función para aplicar filtros rápidos
    aplicarFiltroRapido(tipo) {
      this.filtroActivo = tipo;
      const hoy = new Date();

      switch (tipo) {
        case "ultimos14Dias":
          this.filtros.fechaInicio = new Date(
            new Date().setDate(hoy.getDate() - 14)
          )
            .toISOString()
            .substr(0, 10);
          this.filtros.fechaFin = hoy.toISOString().substr(0, 10);
          break;
        case "ultimoMes":
          this.filtros.fechaInicio = new Date(
            new Date().setMonth(hoy.getMonth() - 1)
          )
            .toISOString()
            .substr(0, 10);
          this.filtros.fechaFin = hoy.toISOString().substr(0, 10);
          break;
        case "ultimoTrimestre":
          this.filtros.fechaInicio = new Date(
            new Date().setMonth(hoy.getMonth() - 3)
          )
            .toISOString()
            .substr(0, 10);
          this.filtros.fechaFin = hoy.toISOString().substr(0, 10);
          break;
        case "ultimoAnio":
          this.filtros.fechaInicio = new Date(
            new Date().setFullYear(hoy.getFullYear() - 1)
          )
            .toISOString()
            .substr(0, 10);
          this.filtros.fechaFin = hoy.toISOString().substr(0, 10);
          break;
        case "desdeInicioAnio":
          this.filtros.fechaInicio = new Date(hoy.getFullYear(), 0, 1)
            .toISOString()
            .substr(0, 10);
          this.filtros.fechaFin = hoy.toISOString().substr(0, 10);
          break;
        case "personalizado":
          // No cambiar fechas, permitir al usuario configurar manualmente
          break;
      }

      // Auto-cargar los presupuestos excepto para personalizado
      if (tipo !== "personalizado") {
        this.cargarPresupuestos();
      }
    },
    async cargarPresupuestos() {
      this.$notiflix.Loading.standard();

      try {
        this.presupuestos = await PresupuestosProvider.getPresupuestos(
          this.filtros.fechaInicio,
          this.filtros.fechaFin
        );
      } catch (error) {
        console.error("Error al cargar presupuestos:", error);
      }
      this.$notiflix.Loading.remove();
    },
    buscarPresupuestos() {
      //console.log("Criterios de búsqueda:", this.filtros);
      this.cargarPresupuestos();
    },
    async handlePresupuestoClick(uuid) {
      await PresupuestosProvider.getPDF(uuid);
    },
    async handleventaClick(uuid) {
      // Ejemplo de navegación pasando parámetros en la ruta
      this.$router.push({
        path: "/venta",
        query: { presupuesto: uuid },
      });

      // await PresupuestosProvider.getPresupuesto(uuid)
    },
    async handleEditClick(uuid) {
      // Ejemplo de navegación pasando parámetros en la ruta
      this.$router.push({
        path: "/presupuesto",
        query: { presupuesto: uuid },
      });

      // await PresupuestosProvider.getPresupuesto(uuid)
    },
    async handleDeleteClick(presupuesto) {
      this.$notiflix.Confirm.show(
        `Advertencia`,
        `Usted va a eliminar el presupuesto de ${presupuesto.CLIENTE} \n ¿Está seguro?`,
        "Si",
        "Cancelar",
        async () => {
          this.$notiflix.Loading.standard();
          await PresupuestosProvider.deletePresupuesto(presupuesto.UUID);
          await this.cargarPresupuestos();
          this.$notiflix.Loading.remove();
          this.$notiflix.Notify.success("Presupuesto eliminada correctamente");
        },
        () => {
          //no hacer nada
        },
        {
          titleColor: "#ef4444",
          okButtonBackground: "#ef4444",
        }
      );
    },
  },
  async mounted() {
    await this.cargarPresupuestos();
  },
};
</script>

<style scoped>
/* Opcional: Agrega estilos personalizados aquí */
</style>
